import * as utils from '@/utils/price'
// 保留小数(精度截取)
export function Amount(data, fix = 2, int = false) {
  return utils.Amount(data, fix, int)
}

// 保留小数(计算)
export function AmountDecimal(data, fix = 2) {
  return utils.AmountDecimal(data, fix)
}

// 获取星期
export function getWeekDay(weekDay) {
  let week = []
  let result = ''
  for (const i of weekDay) {
    switch (Number(i)) {
      case 1:
        week.push('周一')
        break
      case 2:
        week.push('周二')
        break
      case 3:
        week.push('周三')
        break
      case 4:
        week.push('周四')
        break
      case 5:
        week.push('周五')
        break
      case 6:
        week.push('周六')
        break
      case 7:
        week.push('周日')
        break
    }
  }
  if (week.length) {
    result = week.join('、')
  }
  return result
}


// WEBPACK FOOTER //
// ./src/filters/index.js